import capitalize from "lodash/capitalize";

export const capitalizeIfNot = (str?: string) => {
  if (!str) {
    return str;
  }

  return str === str.toUpperCase() ? capitalize(str) : str;
};

export const getVisibleName = (name?: string, index?: number) => {
  if (!name) {
    return "";
  }
  const visibleLength = (index ?? 0) + 1;
  return name.slice(0, visibleLength);
};

export const maskNameByIndex = (name?: string, index?: number) => {
  if (!name) {
    return "";
  }
  const visibleLength = (index ?? 0) + 1;
  const visible = getVisibleName(name, index);
  const hidden = "*".repeat(Math.max(name.length - visibleLength, 0));

  return visible + hidden;
};

export const maskName = (customerName?: string) => {
  if (!customerName) {
    return "";
  }

  const cleanName = customerName.replace(/\s+/g, " ").trim();
  const parts = cleanName.split(" ");

  if (parts.length < 2) {
    // Display the first 2 characters of the name, mask the rest
    return maskNameByIndex(cleanName, 1);
  }
  const lastPart = parts[parts.length - 1];
  return `${parts.slice(0, -1).join(" ")} ${maskNameByIndex(lastPart)}`;
};
